import React from 'react';
import parse from 'html-react-parser';

class QuestionComponent extends React.Component {
  render () {
    return (
      <span>

        <div className="content settlement-detail-overview">
          {parse (this.props.questionText)}       
          {/* h5 was enclosing the parse                        */}
          {/* <div className="question-settlement"> was relaced by content settlement-detail-overview */}
          <div className="following-cities drop_c_width">
            {this.props.QuestionOptions}
          </div>
        </div>
      </span>
    );
  }
}
export default QuestionComponent;
